import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import styles from './ErrorDialog.module.css';
import { selectError, clearError } from '../redux/ApiSlice'; // Assume clearError action exists

const centerStyle = {
    justifyContent: 'center'
};

export default function ErrorDialog() {
    const [isOpen, setIsOpen] = useState(false);
    const error = useSelector(selectError);
    const dispatch = useDispatch();

    const errorMessage = error?.message;

    useEffect(() => {
        if (errorMessage) {
            setIsOpen(true);
        }
    }, [errorMessage]);

    const onClose = () => {
        setIsOpen(false);
        if (typeof clearError === 'function') {
            dispatch(clearError());
        }
    };

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            aria-labelledby="error-dialog-title"
        >
            <DialogTitle id="error-dialog-title">Error</DialogTitle>
            <DialogContent>
                {errorMessage && (
                    <div className={styles.error}>{errorMessage}</div>
                )}
            </DialogContent>
            <DialogActions style={centerStyle}>
                <Button onClick={onClose} color="primary" autoFocus>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
}